class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey =
      parsedState?.key ||
      (Array.isArray(parsedState?.items) && parsedState.items[0] ? parsedState.items[0].key : null);
    const addedVariantId =
      parsedState?.variant_id ||
      parsedState?.id ||
      (Array.isArray(parsedState?.items) && parsedState.items[0]
        ? parsedState.items[0].variant_id || parsedState.items[0].id
        : null);

    let sections = parsedState?.sections;
    if (!sections) {
      try {
        const sectionIds = this.getSectionsToRender()
          .map((section) => section.id)
          .join(',');
        const res = await fetch(`${window.routes?.cart_url || '/cart'}?sections=${sectionIds}`);
        if (res.ok) sections = await res.json();
      } catch (e) {
        console.error('CartNotification section fetch failed:', e);
      }
    }

    if (sections) {
      this.getSectionsToRender().forEach((section) => {
        const targetEl = document.getElementById(section.id);
        const sectionHtml = sections[section.id];
        if (!targetEl || !sectionHtml) return;

        const innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector, addedVariantId);
        if (innerHTML !== null) {
          targetEl.innerHTML = innerHTML;
        }
      });
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', fallbackVariantId = null) {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let el = selector ? doc.querySelector(selector) : null;
    if (!el && fallbackVariantId && selector && selector.includes('cart-notification-product')) {
      el = doc.querySelector(`[id^="cart-notification-product-${fallbackVariantId}:"]`);
    }
    if (!el && selector && selector.includes('cart-notification-product')) {
      el = doc.querySelector('.cart-item');
    }
    if (!el && selector !== '.shopify-section') {
      el = doc.querySelector('.shopify-section');
    }
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
